import { render } from "./Application.vue?vue&type=template&id=198878be&scoped=true"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"

import "./Application.vue?vue&type=style&index=0&id=198878be&lang=scss&scoped=true"
import "./Application.vue?vue&type=style&index=1&id=198878be&lang=scss"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198878be"]])

export default __exports__